import ViewBase from "../../../../framework/core/mvvm/view_base";

const { ccclass, property, menu} = cc._decorator;


@ccclass
@menu("package/hall/hall/hallbaseView")
export default class HallBaseView extends ViewBase {

    @property(cc.Node)
    background2 : cc.Node = null

    @property(cc.Node)
    role : cc.Node = null

    @property(cc.Node)
    bgDecorate : cc.Node = null;

    @property(cc.Node)
    chuan2 : cc.Node = null


    public updateBgDecorate(state :boolean){
        
        this.bgDecorate.active = state;
    }
}
